// extracted by mini-css-extract-plugin
export default {"hiddenInput":"NdsUploader_hiddenInput__D+Afr"};